import React, {useState, useEffect } from 'react';

import { AiFillEye } from 'react-icons/ai'
import { motion } from 'framer-motion'

import { AppWrap, MotionWrap  } from '../../wrapper';
import { readClient } from '../../client';
import { getSanityImageProps } from '../../utils/sanityImage';

import './Work.scss';

const getUniqueTags = (tags = []) => {
  const seenTags = new Set();
  const tagList = Array.isArray(tags) ? tags : [];

  return tagList.reduce((uniqueTags, tag) => {
    if (typeof tag !== 'string') return uniqueTags;

    const trimmedTag = tag.trim();
    const tagKey = trimmedTag.toLowerCase();

    if (!trimmedTag || seenTags.has(tagKey)) return uniqueTags;

    seenTags.add(tagKey);
    return [...uniqueTags, trimmedTag];
  }, []);
};

const Work = () => {

  const [activeFilter, setActiveFilter] = useState('All')
  const [animateCard, setAnimateCard] = useState({y: 0, opacity: 1})
  const [works, setWorks] = useState([])
  const [filterWork, setFilterWork] = useState([])
  const [skills, setSkills] = useState(['React JS', 'Web App', 'Node JS', 'Firebase', 'All'])

  useEffect(() => {
    const query = '*[_type == "works"]';

    readClient.fetch(query)
    .then((data) => {
      const sanitizedWorks = data.map((work) => ({
        ...work,
        tags: getUniqueTags(work.tags),
      }));

      setWorks(sanitizedWorks)
      setFilterWork(sanitizedWorks)
    })
  
   
  }, [])

  useEffect(() => {
    const tags = getUniqueTags(works.flatMap((work) => work.tags));
    setSkills([...tags, 'All'])
  }, [works])
  
  const handleWorkFilter = (item) => {
    setActiveFilter(item)
    setAnimateCard([{y: 100, opacity: 0}])

    setTimeout(() =>{
      setAnimateCard([{y: 0, opacity: 1}])

      if(item === 'All'){
        setFilterWork(works)
      }else{
        
        setFilterWork(works.filter((work) => work.tags.includes(item)))
      }
    }, 500)
  }
  return (
    <>
      <h2 className="head-text">My Creative <span>Portfolio</span></h2>   

      <div className="app__work-filter">
        {skills.map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}
          >
            {item}
          </div>
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{duration: 0.5, delayChildren: 0.5 }}
        className='app__work-portfolio'
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex">
              <img
                {...getSanityImageProps(work.imgUrl, {
                  candidates: [
                    { width: 270, height: 230 },
                    { width: 540, height: 460 },
                    { width: 940, height: 700 },
                  ],
                  sizes: '(min-width: 2000px) 470px, (max-width: 300px) calc(100vw - 32px), 270px',
                })}
                loading="lazy"
                decoding="async"
                alt={`${work.title} project preview`}
              />

              <motion.div
                whileHover={{opacity: [0, 1]}}
                transition={{duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5}}
                className='app__work-hover app__flex'
              >

                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                  whileHover={{scale: [1, 0.9]}}
                  whileInView={{scale: [0, 1]}}
                  transition={{duration: 0.25}}
                  className='app__flex'
                  >
                    <AiFillEye />
                  </motion.div>
                </a>

              </motion.div>
            </div>

            <div className="app__flex app__work-content">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }} >{work.description}</p>

              {work.tags[0] && (
                <div className="app__work-tag app__flex">
                  <p className="p-text">{work.tags[0]}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </motion.div>
      
    </>
  )
}

export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'work',
  "app__primarygray"
  );
